import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowIcon, HomeIcon } from "@/assets/icons";
import { useBreadcrumb } from "@/shared/hooks/useBreadcrumb";
import { BreadcrumbItem } from "@/shared/types/breadcrumb";

export default function Breadcrumb() {
  const { t } = useTranslation();
  const { breadcrumbs } = useBreadcrumb();
  const navigate = useNavigate();
  const isOnlyItem = breadcrumbs.length === 1;

  return (
    <div className="w-full bg-gray-50 mb-6">
      <nav className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between text-sm text-gray-600">
        <div className="flex items-center space-x-1">
          {breadcrumbs.map((item: BreadcrumbItem, index: number) => {
            const isFirst = index === 0;
            const isLast = index === breadcrumbs.length - 1;
            const showLink = item.path && (!isLast || isOnlyItem);

            return (
              <div key={index} className="flex items-center">
                {showLink ? (
                  <Link
                    to={item.path!}
                    className={`flex items-center text-gray-600 hover:text-gray-900 transition-colors group ${
                      isFirst ? "p-2 -m-2 rounded-md" : ""
                    }`}
                  >
                    {isFirst ? (
                      <HomeIcon
                        size={16}
                        className="text-gray-500 group-hover:text-gray-900 transition-colors"
                      />
                    ) : isLast ? (
                      <span className="text-gray-900 font-medium">
                        {item.label}
                      </span>
                    ) : (
                      item.label
                    )}
                  </Link>
                ) : (
                  <span
                    className={`text-gray-900 font-medium ${
                      isFirst ? "p-2 -m-2" : ""
                    }`}
                  >
                    {isFirst ? (
                      <HomeIcon size={16} className="text-gray-500" />
                    ) : (
                      item.label
                    )}
                  </span>
                )}
                {!isLast && <span className="mx-2 text-gray-400">/</span>}
              </div>
            );
          })}
        </div>
        <button
          onClick={() => navigate(-1)}
          className="bg-gray-50 flex items-center text-gray-900 hover:text-gray-700 transition-colors font-medium cursor-pointer"
          title={t("common.back")}
        >
          <ArrowIcon direction="left" size={16} className="mr-1" />
          <span>{t("common.back")}</span>
        </button>
      </nav>
    </div>
  );
}
